import DataTable from '../DataTable'
import TableCell from '@mui/material/TableCell';
import DownloadPdfLink from '../DownloadPdfLink'
import { StyledTableRow } from '../tableStyles/twoColourRows'
import Tracker from '../Tracker';
import { useState, useEffect } from 'react';

export default function UkFundReporting({ fund, fundsClient }) {
    const [reports, setReports] = useState()
    useEffect(async () => {
        setReports(await fundsClient.getUkFundReportingReports(fund.id))

    }, [fund])
    return (
        <div>
            <Tracker page={'Uk Fund Reporting'} />
            <h2>Uk Fund Reporting</h2>
            <hr />
            <DataTable columnNames={['Year']}
                containerStyle={{ marginTop: '2vh', opacity: '0.9' }}>
                {reports?.map(year => {
                    return (<StyledTableRow>
                        <TableCell align='center'>
                            <DownloadPdfLink arrayBufferPromise={async () => await fundsClient.getUkFundReportingReport(fund.id, year)} filename='uk-reporting-fund-status'>
                                {year}
                            </DownloadPdfLink>
                        </TableCell>
                    </StyledTableRow>
                    )
                })}
            </DataTable>
        </div>
    )
}